import React, { forwardRef } from 'react';
import styled from 'styled-components';
import { Toast } from 'zarm';
import { stringify } from 'qs';
import session from '@/store/session';
import { fetchFileById, previweFile } from '@/services/supervision';
import { isPreviewMode } from '@/utils/tool';
import './index.less';
import PDFView from '@/components/PDFView';
const TabList = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    list = [],
    tabValue,
    noPopUp = false
  } = props;

  const gotoUrl = (url, type) => {
    if (isPreviewMode()) {
      return;
    }

    if (!noPopUp) {
      session.set('supervisionPopupShow', true);
      session.set('supervisionPopupShowTab', tabValue);
    } // const link = url && url.replace(/^http:/, 'https:');


    PDFView.view(url);
  };

  const fetchFile = async (fileId, fileType) => {
    const res = await fetchFileById({
      id: fileId
    });
    const {
      message,
      success,
      result = {}
    } = res;

    if (!success) {
      Toast.show(message || '网络异常，请稍后重试');
      return;
    }

    const {
      name
    } = result;
    const url = `/api/v1/document/previewFile?${stringify({
      fileName: `${name}.pdf`
    })}`;
    gotoUrl(url);
  };

  return /*#__PURE__*/React.createElement(Wrapper, null, /*#__PURE__*/React.createElement("div", {
    className: "c-tabList-com",
    ref: ref
  }, list && list.map(item => {
    if (item.relation === 'files') {
      return item.files.map(fileItem => {
        return /*#__PURE__*/React.createElement("div", {
          "data-file-name": fileItem.name,
          "data-file-id": fileItem.id,
          "data-file-type": fileItem.type,
          onClick: () => {
            fetchFile(fileItem.id, fileItem.type);
          },
          className: "item"
        }, /*#__PURE__*/React.createElement("span", null, fileItem.name));
      });
    }

    if (item.relation === 'clause') {
      return item.clause.map(fileItem => {
        return /*#__PURE__*/React.createElement("div", {
          "data-href": fileItem.url,
          onClick: () => {
            gotoUrl(fileItem.url);
          },
          className: "item"
        }, /*#__PURE__*/React.createElement("span", null, fileItem.title));
      });
    }

    return null;
  })));
});
export default TabList;
const Wrapper = styled.div`
  & .c-tabList-com {
    padding-bottom: 110px;
  }
`;